import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { useImageSrc } from '@ff-os/shared-react/hooks/useImageSrc';
import { selectHasSingleNonPinnedVariable } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { findReplaceTranslationKey } from '@ff-scene-plugins/gift-shared/findReplaceTranslationKey';
import { selectPrivateAssetUrl } from '../_redux';
import { PhotoInputContainer } from './PhotoInputContainer';
import styles from './PhotoUploaderInputControl.module.scss';

export const _PhotoInputWindowContext = ({
    showSingleInput, variableIds,
    assetUrl, name
}: Props) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const onClose = useCloseWindow(() => setIsOpen(false));

    const imageSrc = useImageSrc(assetUrl);

    const icon = imageSrc
        ? <img src={imageSrc} className={styles.image} alt='icon' />
        : <Icon type='option-image' />;

    const title = imageSrc
        ? t(findReplaceTranslationKey(name, 'image_uploader.title_replace'))
        : t(name || 'image_uploader.title');

    const navigateBackToOverview = () => {
        onClose();
        setIsOpen(false);
    };

    if (showSingleInput) {
        return <PhotoInputContainer variableIds={variableIds} />;
    }

    return (
        <>
            <WindowButton chevron icon={icon} onClick={() => setIsOpen(true)}>
                {title}
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen(false)}>
                <WindowContext.Header>
                    <WindowHeader previous={onClose}>
                        {title}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <PhotoInputContainer
                        variableIds={variableIds}
                        onConfirm={navigateBackToOverview} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={onClose}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

type Props = OwnProps & {
    showSingleInput: boolean;
    assetUrl: string | undefined;
    name: string | undefined;
};

type OwnProps = {
    variableIds: string[];
};

const mapStateToProps = (state: GiftPdpState, ownProps: OwnProps) => ({
    showSingleInput: selectHasSingleNonPinnedVariable(state),
    assetUrl: selectPrivateAssetUrl(state, ownProps.variableIds[0])
});

export const PhotoInputWindowContext = connect(
    mapStateToProps
)(_PhotoInputWindowContext);